// React
import React, { Suspense } from 'react';

// Vendors
import { Outlet } from 'react-router-dom';

// Src
import TheHeader from './components/TheHeader/TheHeader';
import TheSideBar from './components/TheSideBar/TheSideBar';
import PageLoader from '@/application/components/PageLoader/PageLoader';

// Styles
import classes from './DefaultLayout.module.scss';

const DefaultLayout = () => {
    return (
        <div className={classes.Root}>
            <TheHeader />

            <div className={classes.PageLayout}>
                <TheSideBar />
                <main className={classes.PageOutlet}>
                    <Suspense fallback={<PageLoader />}>
                        <Outlet />
                    </Suspense>
                </main>
            </div>
        </div>
    );
};

export default DefaultLayout;
